<template>
  <model-form
    :model="locationGroup"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-center">
        <model-form-input
          field="name"
          class="col-12"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
          :disable="!$isPermitted($permissions.HardwareAndRegisterStation.Manage)"
        />
        <q-select
          v-model="locationGroup.printerSource"
          class="col-6"
          label="Printer Source"
          :options="$mh.asOptions(PRINTER_SOURCE_TYPES.ALL)"
          map-options
          emit-value
          bottom-slots
          :rules="[val => !!val || 'Field is required']"
        />
        <q-select
          v-if="locationGroup.printerSource === PRINTER_SOURCE_TYPES.HARDWARE"
          v-model="locationGroup.printer"
          class="col-6"
          label="Printer"
          :options="hardwares.data"
          option-label="name"
          clearable
          bottom-slots
        />
        <q-select
          v-else-if="locationGroup.printerSource === PRINTER_SOURCE_TYPES.REGISTER"
          v-model="locationGroup.registerStation"
          class="col-6"
          label="Register"
          :options="$_.filter(registerStations.data, 'isUnarchived')"
          option-label="name"
          clearable
          bottom-slots
        />
        <q-select
          v-else-if="locationGroup.printerSource === PRINTER_SOURCE_TYPES.KITCHEN_DISPLAY"
          v-model="locationGroup.kitchenDisplay"
          class="col-6"
          label="Kitchen Display"
          :options="$_.filter(kitchenDisplays.data, 'isUnarchived')"
          option-label="name"
          clearable
          bottom-slots
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import { PRINTER_SOURCE_TYPES } from 'src/models/location/LocationGroup'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'LocationForm',
  components: {
    ModelForm
  },
  configuration: ['kitchenDisplays', 'registerStations'],
  models: {
    locationGroup: {
      printer: {
        fields: ['id', 'name']
      },
      kitchenDisplay: {
        fields: ['id', 'name']
      },
      registerStation: {
        fields: ['id', 'name']
      }
    },
    hardwares: {
      fields: ['id', 'name']
    }
  },
  created () {
    _.extend(this, { PRINTER_SOURCE_TYPES })
  }
}

</script>
